<template>
    <div class="campaign-box">
        <div class="campaign-option">
            <div class="campaign-option--title">Campaign Name</div>
            <div class="clearfix"></div>
            <div class="campaign-option--subtitle">
                Set a name for the campaign
            </div>
            <input id="campaign_name" type="text" v-model="name" class="campaign-editor__name--input text-input" placeholder="Enter a name for the campaign" required>
            <label v-show="showErrors && !validation.name" class="error" v-cloak>The Campaign Name field is required.</label>
            <label v-show="!validation.nameUnique" class="error" v-cloak>The Campaign Name already exists.</label>
        </div>
    </div>
</template>

<script type="text/babel">
    export default {
        props: [
            'value',
            'validation',
            'showErrors'
        ],

        data() {
            return {
                name: this.value
            }
        },

        watch: {
            value(val) {
                this.name = val;
            },

            name(value) {
                this.$emit('input', value);
            }
        }
    }
</script>
